function getParam(params, key) {
  if (params instanceof URLSearchParams) {
    return (params.get(key) || '').trim();
  }
  const v = params[key];
  return v != null && v !== '' ? String(v).trim() : '';
}

/** True when the URL includes enough search criteria to load results. */
export function hasSearchQuery(type, params) {
  switch (type) {
    case 'flights':
      return Boolean(
        getParam(params, 'from') || getParam(params, 'to') || getParam(params, 'depart')
      );
    case 'hotels':
      return Boolean(getParam(params, 'destination') || getParam(params, 'checkIn'));
    case 'cars':
      return Boolean(getParam(params, 'pickup') || getParam(params, 'pickupDate'));
    case 'packages':
      return Boolean(getParam(params, 'destination') || getParam(params, 'depart'));
    case 'cruises':
      return Boolean(
        getParam(params, 'port') ||
          getParam(params, 'destination') ||
          getParam(params, 'depart')
      );
    default:
      return false;
  }
}

export const SEARCH_PROMPTS = {
  flights: 'Enter your route and travel dates to see available flights.',
  hotels: 'Enter your destination and stay dates to see available hotels.',
  cars: 'Enter your pick-up location and dates to see available rentals.',
  packages: 'Enter your package destination and travel dates to see sample packages.',
  cruises: 'Enter your cruise port, region, and departure date to see sailings.',
};
